/**
 * Admin Frontend — API configuration
 * Single source of truth for all API URL construction.
 *
 * Backend runs on port 8000 (shared with user frontend).
 * Admin frontend runs on port 3001.
 */

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const API_V1_URL = `${API_BASE_URL}/api/v1`;
